import { X, ExternalLink } from "lucide-react";
import "./LiquidCheatsheet.css";

const VARIABLES = [
  { name: "firstName / first_name", desc: "Recipient's first name" },
  { name: "lastName / last_name", desc: "Recipient's last name" },
  { name: "email", desc: "Recipient's email" },
  { name: "company", desc: "Recipient's company" },
  { name: "jobTitle / job_title", desc: "Recipient's job title" },
  { name: "industry", desc: "Recipient's industry" },
  { name: "location", desc: "Recipient's location" },
  { name: "phone / phone_number", desc: "Recipient's phone" },
  { name: "sendingAccountName", desc: "Full name of the sending email account" },
  { name: "sendingAccountFirstName", desc: "First name of the sending account" },
  { name: "sendingAccountEmail", desc: "Email address of the sending account" },
  { name: "sequence_email_opened", desc: "true if any prior step in this campaign was opened" },
  { name: "now", desc: "Current UTC timestamp — use with the date filter" },
];

const SYNTAX = [
  {
    label: "Output a variable",
    code: `Hi {{firstName}},`,
  },
  {
    label: "Default fallback",
    code: `Hi {{ firstName | default: "there" }},`,
  },
  {
    label: "If / elsif / else",
    code: `{% if jobTitle == "founder" %}As a founder...{% elsif industry == "SaaS" %}In SaaS...{% else %}Hello,{% endif %}`,
  },
  {
    label: "Case / when",
    code: `{% case industry %}{% when "SaaS" %}SaaS pitch{% when "Retail" %}Retail pitch{% endcase %}`,
  },
  {
    label: "Assign + filter chain",
    code: `{% assign hour = 'now' | date: "%H" | plus: 0 %}{% if hour < 12 %}morning{% else %}afternoon{% endif %}`,
  },
  {
    label: "Date formatting",
    code: `Today is {{ 'now' | date: "%B %d, %Y" }}`,
  },
  {
    label: "Branch on prior open",
    code: `{% if sequence_email_opened %}Just following up...{% else %}Hi {{firstName}},{% endif %}`,
  },
];

export default function LiquidCheatsheet({ onClose }) {
  return (
    <div className="liquid-cheatsheet-backdrop" onClick={onClose}>
      <div className="liquid-cheatsheet" onClick={(e) => e.stopPropagation()}>
        <div className="liquid-cheatsheet-header">
          <div>
            <h3>Liquid Reference</h3>
            <p>Personalize emails with variables, conditionals, and filters.</p>
          </div>
          <button type="button" className="liquid-cheatsheet-close" onClick={onClose} aria-label="Close">
            <X size={18} />
          </button>
        </div>

        <div className="liquid-cheatsheet-body">
          <section>
            <h4>Variables</h4>
            <table className="liquid-cheatsheet-vars">
              <tbody>
                {VARIABLES.map((v) => (
                  <tr key={v.name}>
                    <td><code>{v.name}</code></td>
                    <td>{v.desc}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="liquid-cheatsheet-note">
              Custom contact fields are also available by their key name.
            </p>
          </section>

          <section>
            <h4>Syntax</h4>
            {SYNTAX.map((s) => (
              <div key={s.label} className="liquid-cheatsheet-syntax">
                <div className="liquid-cheatsheet-syntax-label">{s.label}</div>
                <pre><code>{s.code}</code></pre>
              </div>
            ))}
          </section>

          <section>
            <h4>Limits</h4>
            <ul className="liquid-cheatsheet-limits">
              <li>Output capped at 256 kB per email</li>
              <li>Loops limited to 5,000 total iterations</li>
              <li>Templates that fail to render at send time are marked failed (not delivered)</li>
            </ul>
          </section>

          <a
            className="liquid-cheatsheet-extlink"
            href="https://shopify.github.io/liquid/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Full Liquid reference <ExternalLink size={12} />
          </a>
        </div>
      </div>
    </div>
  );
}
